<div class="row mt-4">
    <div class="col">
        <div class="form-inline">
            <span class="badge badge-warning">
                <span class="material-icons">
                    grade
                </span>
            </span>
            <h4 class="mt-2">Mis calificaciones</h4>
        </div>
    </div>
</div>
<div class="d-flex flex-row justify-content-end">
    <form [formGroup]="calificationPeriod">
        <div class="btn-group">
            <div class="form-group">
                <select class="form-control border-info" formControlName="year">
                    <option value="" disabled>Año a mostrar</option>
                    <option [ngValue]="2021">2021</option>
                    <option [ngValue]="2022">2022</option>
                    <option [ngValue]="2023">2023</option>
                    <option [ngValue]="2024">2024</option>
                    <option [ngValue]="2025">2025</option>
                    <option [ngValue]="2026">2026</option>
                </select>
            </div>
            <div class="form-group">
                <select class="form-control border-info" formControlName="month">
                    <option value="" disabled>Mes a mostrar</option>
                    <option [ngValue]="1">Enero</option>
                    <option [ngValue]="2">Febrero</option>
                    <option [ngValue]="3">Marzo</option>
                    <option [ngValue]="4">Abril</option>
                    <option [ngValue]="5">Mayo</option>
                    <option [ngValue]="6">Junio</option>
                    <option [ngValue]="7">Julio</option>
                    <option [ngValue]="8">Agosto</option>
                    <option [ngValue]="9">Septiembre</option>
                    <option [ngValue]="10">Octubre</option>
                    <option [ngValue]="11">Noviembre</option>
                    <option [ngValue]="12">Diciembre</option>
                </select>
            </div>
        </div>
    </form>
</div>
<div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" *ngIf="calification">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Mi calificación: {{returnMonthName()}}
                </h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <google-chart [type]="'Gauge'" [width]="200" [height]="200"
                        [data]="[['Calificación', calification.calification]]" [options]="gaugeChartOptions">
                    </google-chart>
                </div>
                <div class="card-footer">
                    <p>Tareas completadas: {{calification.checkPointsDone}}</p>
                    <p>Total: {{calification.mustHaveCheckPointsDone}}</p>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="user && user.role === 'auditor'">
    <div class="row" *ngFor="let job of jobsInCharge">
        <div class="col-12">
            <h4 class="card-title">Supervisores</h4>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12" *ngFor="let supervisor of supervisors">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{supervisor.fullName}} {{supervisor.jobName}}</h4>
                </div>
                <div class="card-content" *ngIf="calificationsAuditor[supervisor.id]">
                    <div class="card-body">
                        <google-chart [type]="'Gauge'" [width]="100" [height]="100"
                            [data]="[['Calificación', calificationsAuditor[supervisor.id].calification]]"
                            [options]="gaugeChartOptions"></google-chart>
                    </div>
                    <div class="card-footer">
                        <p>Tareas completadas: {{calificationsAuditor[supervisor.id].checkPointsDone}}</p>
                        <p>Total: {{calificationsAuditor[supervisor.id].mustHaveCheckPointsDone}}</p>
                    </div>
                </div>
                <div class="card-content" *ngIf="!calificationsAuditor[supervisor.id]">
                    <div class="card-body">
                        El supervisor no tiene registros en este mes
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="user && (user.role === 'supervisor' || user.role === 'auditor')">
    <div class="row mb-5" *ngFor="let job of jobsInCharge">
        <div class="col-12">
            <h4 class="card-title">Puesto: {{job.name}}</h4>
        </div>
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-12" *ngFor="let employeeInCharge of employeesInCharge[job.id]">
            <div class="card h-100">
                <div class="card-header">
                    <h4 class="card-title">{{employeeInCharge.fullName}}</h4>
                </div>
                <div class="card-content" *ngIf="calificationsSupervisor[employeeInCharge.id]">
                    <div class="card-body">
                        <google-chart [type]="'Gauge'" [width]="100" [height]="100"
                            [data]="[['Calificación', calificationsSupervisor[employeeInCharge.id].calification]]"
                            [options]="gaugeChartOptions"></google-chart>
                    </div>
                    <div class="card-footer">
                        <p>Tareas completadas: {{calificationsSupervisor[employeeInCharge.id].checkPointsDone}}</p>
                        <p>Total: {{calificationsSupervisor[employeeInCharge.id].mustHaveCheckPointsDone}}</p>
                    </div>
                </div>
                <div class="card-content" *ngIf="!calificationsSupervisor[employeeInCharge.id]">
                    <div class="card-body">
                        El empleado no tiene registros en este mes
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ngx-spinner></ngx-spinner>